import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Button, Form, InputGroup, Col, Row, Container, Modal, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditCartModal from '../elements/EditCartModal';
import { checkCouponThunk, clearCoupon } from '../store/coupons';
import { useDispatch, useSelector } from 'react-redux';
import EditFreeItemModal from '../elements/EditFreeItemModal';
// import { getFreeItemsThunk } from '../store/freeitems';
import { placeOrderThunkPayInStore } from '../store/cart';
import { useNavigate } from 'react-router-dom';
import CheckoutApp from '../elements/StripeCheckoutApp';
import loadingJson from '../assets/json/loading.json';
import Lottie from 'react-lottie-player';
import { Context } from '../context/AppContext';
import Header from '../components/Header';
import { checkIfLunchTime, isStoreOpen, showTimeError } from '../Utilts/helper';
import { faBagShopping, faMapMarkerAlt, faStore, faTruck, faChevronRight, faShoppingBag, faChevronDown, faChevronUp, faArrowLeft, 
  faCreditCard, faMoneyBillWave, faSpinner, faReceipt,  faTags, faCheckCircle, faTimesCircle, faExclamationTriangle
  } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import AddressModal from '../elements/AddressModal';
import { motion, AnimatePresence } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import { getHoursThunk, getOnlineStatusThunk } from '../store/restaurants';

const THEME_COLOR = "#9d2a00";

const CheckoutPage = ({ fee }) => {
  const navigate = useNavigate();
  const { setTipAmount, language, changedCart, setChangedCart, restaurantId, setRestaurantId } = useContext(Context)
  const [promoCode, setPromoCode] = useState('');
  const [orderMethod, setOrderMethod] = useState('pickup'); // pickup or delivery
  const [cartOpen, setCartOpen] = useState(true); // State to toggle cart items
  const [editCartModal, setEditCartModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentUserAddress, setCurrentUserAddress] = useState(null);
  const [addressVerified, setAddressVerified] = useState(false);
  const [addressErrors, setAddressErrors] = useState('');
  const [needDelivery, setNeedDelivery] = useState(false);
  const [checkingCoupon, setCheckingCoupon] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [tip, setTip] = useState(10);
  const [customTip, setCustomTip] = useState(0);
  const [showTipModal, setShowTipModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false); // State for payment modal
  const dispatch = useDispatch();
  const checkCoupon = useSelector(state => state.coupons.coupon);
  const [editFreeItem, setEditFreeItem] = useState(false);
  const freeItems = useSelector((state) => state.freeitems.freeitems);
  const [paymentOption, setPaymentOption] = useState('online');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(false);
  const [payinStoreLoading, setPayinStoreLoading] = useState(false);  // State for loading spinner
  const [paymentSubmitLoading, setPaymentSubmitLoading] = useState(false);  // State for loading spinner
  const [showChooseRestaurant, setShowChooseRestaurant] = useState(false);
  const cart = JSON.parse(localStorage.getItem(`cart${restaurantId}`)) || [];
  const freeItem = JSON.parse(localStorage.getItem(`freeItem${restaurantId}`)) || [];
  const restaurantStatus = useSelector(state => state.restaurant.onlineStatus);
  const restaurantHours = useSelector(state => state.restaurant.hours);
  
  const [needSchdule, setNeedSchdule] = useState(false);

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [distanceText, setDistanceText] = useState('');
  const [addressInput, setAddressInput] = useState('');
  const [errorStatus, setErrorStatus] = useState(null); // null, 'success', 'error'
  const nameRef = React.createRef();
  const phoneRef = React.createRef();


const restaurantAddress =
  restaurantId === 7
    ? "1250 N Germantown Pkwy #105, Cordova, TN 38016"
    : restaurantId === 11
    ? "2110 Madison Ave, Memphis, TN 38104"
    : restaurantId === 40
    ? "149 Madison Ave, Memphis, TN 38103"
    : restaurantId === 73
    ? "5167 Poplar Ave, Memphis, TN 38117"
    : "";

console.log(restaurantStatus, restaurantHours)
  useEffect(() => { 
    if (!restaurantId) {
      setShowChooseRestaurant(true);
    }else {
      dispatch(getOnlineStatusThunk(restaurantId));
      dispatch(getHoursThunk(restaurantId));
    }
  },[restaurantId]);

  

  useEffect(() => {
    if (!showPaymentModal) {
      setName('');
      setPhone('');
      setError('');
      setActiveTab(false);
    }
  }, [showPaymentModal])



  // useEffect(() => { 
  //   if (restaurantId) {
  //     dispatch(getFreeItemsThunk(restaurantId));
  //   }
  // },[restaurantId, dispatch]);

  useEffect(() => {
    if (needDelivery) {
      handleScriptLoad();
      handleStoreMap();
    } else {
      handleStoreMap();
    }
  }, [needDelivery, currentUserAddress, restaurantId]);

  let autocomplete;
  const handleScriptLoad = () => {
    /*global google*/ // To disable any eslint 'google not defined' errors
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      { types: ["geocode"] }
    );

    autocomplete.addListener("place_changed", handlePlaceSelect);
  };

  function handlePlaceSelect() {
    let place = autocomplete.getPlace();

    if (!place.geometry) {
      setAddressErrors('Please enter a valid address')

      document.getElementById("autocomplete").value = "";

      return;
    } else {

      const res = checkDistance(place.formatted_address)
      res.then((result) => {
        if (result) {
          setCurrentUserAddress(place.formatted_address);
          setAddressVerified(true);
          setAddressErrors('');
        }
      })
    }
  }

const checkDistance = async (userAddress) => {
  const geocoder = new google.maps.Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: userAddress }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        const userLocation = results[0].geometry.location;

        // Define restaurant coordinates by ID
        let restaurantCoords;
        switch (restaurantId) {
          case 7: // Cordova
            restaurantCoords = { lat: 35.1587, lng: -89.793788 };
            break;
          case 11: // Overton Square
            restaurantCoords = { lat: 35.1369603, lng: -89.9909528 };
            break;
          case 40: // Downtown
            restaurantCoords = { lat: 35.1452087, lng: -90.0529371 };
            break;
          case 73: // Little Petal Chinese 2 - Poplar Ave
            restaurantCoords = { lat: 35.1096462, lng: -89.889768 };
            break;
          default:
            restaurantCoords = { lat: 35.1369603, lng: -89.9909528 }; // fallback
        }

        const restaurantLocation = new google.maps.LatLng(
          restaurantCoords.lat,
          restaurantCoords.lng
        );

        // Calculate distance between user's location and restaurant's location
        const distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(
          userLocation,
          restaurantLocation
        );
        const distanceInMiles = distanceInMeters * 0.000621371; // meters → miles

        // Within 5 miles = OK
        if (distanceInMiles <= 5) {
          setAddressErrors("");
          setAddressVerified(true);
          resolve(true);
        } else {
          setAddressErrors(
            "Sorry, we cannot deliver to addresses more than 5 miles away."
          );
          setAddressVerified(false);
          resolve(false);
        }
      } else {
        setAddressErrors(
          "Unable to verify this address. Please check and try again."
        );
        setAddressVerified(false);
        resolve(false);
      }
    });
  });
};

const handleStoreMap = () => {
  /* global google */

  // Define restaurant coordinates by ID
  let restaurantCoords;
  switch (restaurantId) {
    case 7: // Cordova
      restaurantCoords = { lat: 35.1587, lng: -89.793788 };
      break;
    case 11: // Overton Square
      restaurantCoords = { lat: 35.1369603, lng: -89.9909528 };
      break;
    case 40: // Downtown
      restaurantCoords = { lat: 35.1452087, lng: -90.0529371 };
      break;
    case 73: // Little Petal Chinese 2 - Poplar Ave
      restaurantCoords = { lat: 35.1096462, lng: -89.889768 };
      break;
    default:
      restaurantCoords = { lat: 35.1369603, lng: -89.9909528 };
  }

  const mapOptions = {
    center: new google.maps.LatLng(restaurantCoords.lat, restaurantCoords.lng),
    zoom: needDelivery ? 10 : 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  };

  const map = new google.maps.Map(document.getElementById("gmp-map"), mapOptions);

  // Add marker for restaurant
  const marker = new google.maps.Marker({
    position: restaurantCoords,
    title: "Petals of a Peony",
    map: map,
  });

  if (needDelivery) {
    // Add delivery range circle (5-mile radius)
    new google.maps.Circle({
      strokeColor: "#9d2a00",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#9d2a00",
      fillOpacity: 0.25,
      map: map,
      center: restaurantCoords,
      radius: 8046.72, // 5 miles in meters
    });
  }
};



  //handle coupon
  const checkCurrentCoupon = async (e) => {
    e.preventDefault();
    setCheckingCoupon(true);
    setCouponError('');
    try {
      await dispatch(checkCouponThunk(promoCode));
    } catch (error) {
      setCheckingCoupon(false);
    } finally {
      setCheckingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setPromoCode('');
    setCouponError('');
    dispatch(clearCoupon(''));
  };

  const handleEditCartModal = (item) => {
    setSelectedItem(item);
    setEditCartModal(true);
  };

  const calculateSubtotal = () => {
    let subtotal = cart.reduce(
      (total, cartItem) => total + cartItem.Item.price * cartItem.quantity,
      0
    );

    cart.forEach((cartItem) => {
      cartItem.options.forEach((option) => {
        subtotal += option.priceModifier * cartItem.quantity;
      });
    });

    return subtotal.toFixed(2);


  };

  const calculateTaxes = () => {
    return (calculateSubtotal() * fee?.tax).toFixed(2);
  };

  const calculateDiscount = () => {
    const subtotal = parseFloat(calculateSubtotal());
    let discount = 0;

    if (checkCoupon && subtotal >= parseFloat(checkCoupon.min_require)) {
      if (checkCoupon.discount_type === 'Percentage') {
        discount = (subtotal * (parseFloat(checkCoupon.discount) / 100)).toFixed(2);
      } else {
        discount = parseFloat(checkCoupon.discount);
      }
    }

    return discount;
  };

  const calculateServiceFee = () => {
    const subtotal = parseFloat(calculateSubtotal());
    return (subtotal * fee?.service_fee + parseFloat(fee?.commission_fee))?.toFixed(2);
  };

  const calculateTip = () => {
    const subtotal = parseFloat(calculateSubtotal());
    return ((subtotal * tip) / 100).toFixed(2);
  };

  const calculateTotal = () => {
    const subtotal = parseFloat(calculateSubtotal());
    const taxes = parseFloat(calculateTaxes());
    const discount = calculateDiscount();
    const commissionFee = parseFloat(fee?.commission_fee);
    const serviceFee = orderMethod === 'delivery' ? parseFloat(calculateServiceFee()) : 0;
    const deliveryFee = orderMethod === 'delivery' ? parseFloat(fee?.delivery_fee) : 0;
    const tipAmount = parseFloat(customTip || calculateTip());

    let total = (subtotal + taxes - discount + serviceFee + deliveryFee + tipAmount).toFixed(2);
    if (orderMethod === 'pickup') {
      total = (parseFloat(total) + commissionFee).toFixed(2);
    }
    return total;
  };

  useEffect(() => {
    if (checkCoupon?.min_require && parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require)) {
      setCouponError('Minimum order amount of $' + checkCoupon.min_require + ' is required to use this coupon.');
    }
  }, [checkCoupon, calculateSubtotal()])

  const handleTipSelect = (percentage) => {
    setTip(percentage)
    setCustomTip(0)
  };

  const handleCustomTip = () => {
    setTip(0);
    setShowTipModal(true);
  };

  const incrementTip = () => setCustomTip(prevTip => +prevTip + 1);
  const decrementTip = () => setCustomTip(prevTip => +Math.max(0, prevTip - 1));


  const handleCustomTipChange = (e) => {
    if (/^\d*$/.test(e.target.value)) { // Allow only digits
      setCustomTip(Number(e.target.value));
    }
    setTip(0); // Reset tip percentage
  };


  const handleEditFreeItem = (item) => {
    setSelectedItem(item);
    setEditFreeItem(true);
  };

  const needAmountReached = () => {
    // Iterate through freeItems array
    const freeItemed = JSON.parse(localStorage.getItem('freeItem'));

    if (freeItemed?.Item) {
      for (const freeItem of freeItems) {
        // Find the matching ReedemableItem based on item 
        for (const item of freeItem.ReedemableItems) {
          if (item?.Item?.id === freeItemed?.Item?.id) {
            return +freeItem.need_amount <= +calculateSubtotal();
          }
        }
      }
    } else {
      return true;
    }
  };
console.log(isStoreOpen(restaurantId, restaurantHours))
  const handlePlaceOrder = () => {
    if(restaurantStatus?.stop_order){
      Swal.fire({
        icon: 'error',
        title: 'Restaurant Too Busy At the Moment',
        text: 'Online order is currently closed!',
      })
      return;
    }

    if (!isStoreOpen(restaurantId, restaurantHours)) {
      showTimeError(restaurantId);
      return
    }

    if (!needAmountReached()) {
      Swal.fire({
        icon: 'error',
        title: 'Free Item Minimum Amount Not Reached',
        text: 'You have not reached the minimum amount to redeem this item, please add more items to your cart to reach the minimum amount!',
      })
      return;
    }

    const iflunchitem = cart.filter(item => item.Item.name.toLowerCase().includes('lunch'))

    if (!checkIfLunchTime() && iflunchitem.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Lunch Time Error',
        text: 'You have lunch items in your cart, lunch items are only available right now!',
      })
      return;
    }

    if(!cart.length){ 
         Swal.fire({
        title: 'Cart Empty',
        text: 'Please add item to your cart to checkout',
      })
      return;
    }

 if (!name && !phone) {
      setErrorStatus(1);
      setError('Please enter your name and phone number.');
      nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!name) {
      setErrorStatus(2);
      setError('Please enter your name.');
      nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!phone) {
      setErrorStatus(3);
      setError('Please enter your phone number.');
      phoneRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!/^\d{10}$/.test(phone.replace(/\D/g, ''))) {
      setErrorStatus(4);
      setError('Please enter a valid phone number.');
      phoneRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setErrorStatus(null);
    setError('');

    setShowPaymentModal(true);
  };

  

   const handlePhoneChange = useCallback((e) => {
    const input = e.target.value.replace(/\D/g, '');
    if (input.length <= 10) setPhone(input);
    if (input === '') setErrorStatus(null);
  }, []);

  const formatPhoneNumber = (phone) => {
    if (phone.length > 6) return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
    if (phone.length > 3) return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
    if (phone.length > 0) return `(${phone}`;
    return '';
  };

  const handlePaymentMethodChange = (selectedOption) => {
    setPaymentOption(selectedOption);
  }

  const handleContinueCheckout = () => {
    if (!paymentOption) {
      setError('Please select a payment method.');
      return
    }


    if (!name || !phone) {
      setError('Please enter your name and phone number.');
      return;
    }

    //only allow numbers for phone, and length of 10
    if (!/^\d{10}$/.test(phone)) {
      setError('Please enter a valid phone number. Only numbers are allowed.');
      return;
    }


    setActiveTab(true);
  }
  const handleSelectSavedAddress = async (addr) => {
    setAddressInput(addr);
    setCurrentUserAddress(addr);
    const ok = await checkDistance(addr);
    if (ok) {
      setAddressVerified(true);
      setAddressErrors('');
      setShowAddressModal(false);
    } else {
      setAddressVerified(false);
      setAddressErrors(`Sorry, we can only deliver up to ${(fee?.max_delivery_range || 5)} miles.`);
    }
  };

  const handleSaveAddress = (a, d) => {
    setAddressVerified(true);

    const key = `savedAddresses_${restaurantId}`;
    const saved = localStorage.getItem(key);
    const savedAddresses = saved ? JSON.parse(saved) : [];
    if (!savedAddresses.includes(addressInput)) {
      savedAddresses.unshift(addressInput);
      localStorage.setItem(key, JSON.stringify(savedAddresses.slice(0, 5)));
    }
    setShowAddressModal(false);
  };


  const handlePayInStore = async () => {
    setPayinStoreLoading(true);
    try {
      await dispatch(placeOrderThunkPayInStore(
        restaurantId,
        paymentOption,
        name,
        phone,
        customTip || calculateTip(),
        currentUserAddress || null,
        cart,
        calculateDiscount() > 0 ? checkCoupon?.coupon_id : null,
        freeItem?.Item ? freeItem : null
      ))
        .then(() => {

          setChangedCart(!changedCart);
          setPayinStoreLoading(false);

          navigate('/order-confirmed/zds/gwzc/ASC/2/4');
        })
    } catch (error) {
      setPayinStoreLoading(false);
      console.error('An error occurred:', error);
      setError('An error occurred. Please try again later.');
    }
  }


  const goBack = () => {
    setActiveTab(false);
  }
  const handleToOrder = (id) => {
    setShowChooseRestaurant(false);
    setRestaurantId(id)
    setChangedCart(!changedCart);
          setCurrentUserAddress(null);
            setAddressInput(null);
            setAddressVerified(false);
            setOrderMethod('pickup');
            setNeedDelivery(false);
            setAddressErrors(null);
            setErrorStatus(null);
            setName('');
            setPhone('');
  }

    const isDelivery = orderMethod === 'delivery';


  return (
    <>
      <Header />
<Modal
  show={showChooseRestaurant}
  size="lg"
  centered
  onHide={() => {}} // ❌ disable closing
  backdrop="static" // ❌ clicking outside won’t close
  keyboard={false}  // ❌ pressing Esc won’t close
>
  {/* Header */}
  <Modal.Header
    className="border-0"
    style={{
      backgroundColor: "#fff9f7",
      borderBottom: "1px solid rgba(157,42,0,0.15)",
    }}
  >
    <Modal.Title className="fw-bold text-dark">
      Please Choose a Location
    </Modal.Title>
  </Modal.Header>

  {/* Body */}
  <Modal.Body
    className="bg-white text-dark"
    style={{
      maxHeight: "80vh",
      overflowY: "auto",
      borderRadius: "0 0 1rem 1rem",
      backgroundColor: "#fff9f7",
    }}
  >
    <div className="container py-4">
      <h4
        className="text-center fw-bold mb-4"
        style={{ color: "#9d2a00" }}
      >
        Our Locations
      </h4>

      <div className="row justify-content-center gy-4">
        {[
          {
            id: 7,
            title: "Cordova Location",
            address: "1250 N Germantown Pkwy",
            city: "Cordova, TN 38016",
            phone: "(901) 707-8886",
          },
          {
            id: 11,
            title: "Overton Square Location",
            address: "2110 Madison Ave",
            city: "Memphis, TN 38104",
            phone: "(901) 207-6680",
          },
          {
            id: 40,
            title: "小富贵 Little Petal Chinese",
            address: "149 Madison Ave",
            city: "Memphis, TN 38103",
            phone: "(901) 628-0086",
          },
          {
            id: 73,
            title: "小富贵 Little Petal Chinese 2",
            address: "5167 Poplar Ave",
            city: "Memphis, TN 38117",
            phone: "(901) 668-9388",
          },
        ].map((loc, idx) => {
          const isSelected = restaurantId === loc.id;
          return (
            <div key={idx} className="col-12 col-md-6 col-lg-6">
              <div
                className={`border rounded-4 shadow-sm h-100 p-4 text-center`}
                style={{
                  transition: "all 0.3s ease",
                  borderColor: isSelected
                    ? "#9d2a00"
                    : "rgba(157,42,0,0.15)",
                  background: isSelected ? "#fff3ef" : "#fff",
                  boxShadow: isSelected
                    ? "0 4px 10px rgba(157,42,0,0.25)"
                    : "0 2px 6px rgba(0,0,0,0.05)",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(157,42,0,0.2)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.boxShadow = isSelected
                    ? "0 4px 10px rgba(157,42,0,0.25)"
                    : "0 2px 6px rgba(0,0,0,0.05)")
                }
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h5 className="fw-bold mb-0 text-dark">{loc.title}</h5>
                  {isSelected && (
                    <span
                      className="badge text-white"
                      style={{
                        backgroundColor: "#9d2a00",
                        fontSize: "0.8rem",
                      }}
                    >
                      Selected
                    </span>
                  )}
                </div>

                <p className="mb-1 fw-medium text-dark">{loc.address}</p>
                <p className="mb-1 text-muted">{loc.city}</p>
                <a
                  href={`tel:${loc.phone.replace(/[^0-9]/g, "")}`}
                  className="text-decoration-none fw-semibold d-block mb-3"
                  style={{ color: "#9d2a00" }}
                >
                  {loc.phone}
                </a>

                <button
                  onClick={() => handleToOrder(loc.id)}
                  className="btn w-100 fw-semibold"
                  style={{
                    backgroundColor: "#9d2a00",
                    color: "#fff",
                    borderRadius: 12,
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#b83500")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#9d2a00")
                  }
                >
                  {isSelected ? "Continue Ordering" : "Order Here"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </Modal.Body>
</Modal>

      <Container className="checkout-page" style={{ marginTop: '80px' }}>
        <Row>
 <Col lg={7} md={12} sm={12}>
  <div
    className="p-4 shadow-sm border rounded-4 bg-white"
    style={{
      borderColor: "rgba(157, 42, 0, 0.15)",
      background: "#fff9f7",
    }}
  >
    {/* Checkout Header */}
    <div className="text-center mb-4">
      <h4 className="fw-bold text-dark mb-0">Checkout</h4>
      <small className="text-muted">
        Choose how you’d like to receive your order
      </small>
    </div>

    {/* Pickup / Delivery Buttons */}
    <div className="d-flex flex-column gap-3 mb-4">
      {/* Pickup */}
      <button
        type="button"
        className={`w-100 py-3 rounded-3 border fw-semibold text-start d-flex align-items-center justify-content-between ${
          orderMethod === "pickup"
            ? "text-white"
            : "text-dark bg-white border "
        }`}
        style={{
          backgroundColor: orderMethod === "pickup" ? "#9d2a00" : "#fff",
          transition: "all 0.2s ease",
          boxShadow: orderMethod === "pickup" ? "0 2px 8px rgba(157,42,0,0.2)" : "none",
          border: orderMethod === "pickup" ? "2px solid #9d2a00" : "1px solid #ccc",
          padding: "1rem 1.25rem",
        }}
        onClick={() => {
          setOrderMethod("pickup");
          setNeedDelivery(false);
          setAddressErrors(null);
          setAddressInput(null);
          setCurrentUserAddress(null);
          setAddressVerified(false);
        }}
      >
        <div className="d-flex align-items-center">
          <FontAwesomeIcon
            icon={faStore}
            className="me-3"
            style={{ fontSize: "1.2rem" }}
          />
          <div>
            <p className="mb-0 fw-semibold">
              Pickup{" "}
              {orderMethod === "pickup" && (
                <span className="badge bg-light text-dark ms-1">Selected</span>
              )}
            </p>
            <small
              className="d-block"
              style={{
                color: orderMethod === "pickup" ? "#fff" : "#555",
                opacity: orderMethod === "pickup" ? 0.9 : 0.8,
              }}
            >
              Standard 10–20 min (ASAP)
            </small>
          </div>
        </div>
        <FontAwesomeIcon
          icon={faChevronRight}
          className={orderMethod === "pickup" ? "text-white" : "text-muted"}
        />
      </button>

      {/* Delivery */}
      {restaurantId !== 11 && (
      <button
        type="button"
        className={`w-100 py-3 rounded-3 border fw-semibold text-start d-flex align-items-center justify-content-between ${
          orderMethod === "delivery"
            ? "text-white"
            : "text-dark bg-white border "
        }`}
        style={{
          backgroundColor: orderMethod === "delivery" ? "#9d2a00" : "#fff",
          transition: "all 0.2s ease",
          boxShadow: orderMethod === "delivery" ? "0 2px 8px rgba(157,42,0,0.2)" : "none",
          border: orderMethod === "delivery" ? "2px solid #9d2a00" : "1px solid #ccc",
          padding: "1rem 1.25rem",
        }}
        onClick={() => {
          setOrderMethod("delivery");
          setNeedDelivery(true);
          setNeedSchdule(false);
        }}
      >
        <div className="d-flex align-items-center">
          <FontAwesomeIcon
            icon={faTruck}
            className="me-3"
            style={{ fontSize: "1.2rem" }}
          />
          <div>
            <p className="mb-0 fw-semibold">
              Delivery{" "}
              {orderMethod === "delivery" && (
                <span className="badge bg-light text-dark ms-1">Selected</span>
              )}
            </p>
            <small
              className="d-block"
              style={{
                color: orderMethod === "delivery" ? "#fff" : "#555",
                opacity: orderMethod === "delivery" ? 0.9 : 0.8,
              }}
            >
              Standard 30–45 min (ASAP)
            </small>
          </div>
        </div>
        <FontAwesomeIcon
          icon={faChevronRight}
          className={orderMethod === "delivery" ? "text-white" : "text-muted"}
        />
      </button>
      )}
    </div>

    {/* Delivery Address Section (only if delivery selected) */}
{orderMethod === "delivery" && (
  <div
    className="section delivery-details mt-4 p-4 border rounded-3 bg-white"
    style={{
      borderColor: "rgba(0,0,0,0.1)",
    }}
  >
    {/* Header */}
    <h5 className="fw-bold text-dark mb-3">
      <i
        className="fas fa-truck me-2"
        style={{ color: "#9d2a00" }}
      ></i>
      Delivery Details
    </h5>

    {/* Address Input */}
    <Form>
      <Form.Group controlId="autocomplete" className="mb-3">
        <Form.Label className="fw-semibold text-dark mb-1">
          Enter your delivery address <span className="text-danger">*</span>
        </Form.Label>
        <div className="position-relative">
          <Form.Control
            type="text"
            placeholder="Start typing your address..."
            className="py-3 ps-3"
            style={{
              borderRadius: "8px",
              borderColor: "rgba(0,0,0,0.2)",
              boxShadow: "none",
            }}
          />
          <i
            className="fas fa-map-marker-alt position-absolute"
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#9d2a00",
              fontSize: "1rem",
            }}
          ></i>
        </div>
      </Form.Group>

      {addressErrors && (
        <p
          className="text-danger mt-2 mb-0"
          style={{
            fontSize: "0.9rem",
          }}
        >
          <i className="fas fa-exclamation-circle me-1"></i>
          {addressErrors}
        </p>
      )}
    </Form>

    {/* Info note */}
    <p
      className="text-muted small mt-3 mb-0"
      style={{ lineHeight: "1.5" }}
    >
      Please ensure your address is within <strong>5 miles</strong> of the
      selected restaurant for delivery.
    </p>
  </div>
)}


    {/* Restaurant Location (shared section) */}
    <div className="mt-4 text-center">
      {/* Desktop Map */}
      <div className="d-none d-md-block">
        <div
          className="rounded-4 overflow-hidden shadow-sm border"
          id="gmp-map"
          style={{
            height: 220,
            borderColor: "rgba(157,42,0,0.15)",
          }}
        ></div>
      </div>

      {/* Info */}
      <div className="mt-3">
        <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
          <div
            className="rounded-circle"
            style={{
              width: 10,
              height: 10,
              backgroundColor: "#28a745",
              boxShadow: "0 0 6px rgba(40,167,69,0.4)",
            }}
          ></div>
          <span className="fw-semibold text-dark small">
            Restaurant Location
          </span>
        </div>

        <p
          className="fw-semibold text-dark mb-3 px-3"
          style={{
            fontSize: "0.95rem",
            lineHeight: 1.4,
          }}
        >
          {restaurantAddress}
        </p>

        <button
          type="button"
          className="btn fw-semibold px-4 py-2"
          onClick={() => {
            setShowChooseRestaurant(true);
      
          
          }}
          style={{
            backgroundColor: "#9d2a00",
            color: "#fff",
            borderRadius: 12,
            fontSize: "0.9rem",
            boxShadow: "0 2px 6px rgba(157,42,0,0.25)",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#b83500")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#9d2a00")}
        >
          Change Location
        </button>
      </div>
    </div>
  </div>
</Col>




          <Col md={5}>
        


            <div
      className="shadow-sm p-4 rounded-4 mt-3 bg-white"
      style={{
        border: `1px solid rgba(157, 42, 0, 0.15)`,
        background: "#fff9f7",
      }}
    >
      {/* Header */}
      <h5
        className="fw-semibold d-flex align-items-center justify-content-between fs-6 mb-3"
        style={{
          cursor: "pointer",
          borderBottom: "2px solid #f1f1f1",
          paddingBottom: "0.5rem",
          color: "#222",
        }}
        onClick={() => setCartOpen(!cartOpen)}
      >
        <span className="d-flex align-items-center gap-2">
          <FontAwesomeIcon
            icon={faShoppingBag}
            style={{ color: THEME_COLOR, fontSize: 18 }}
          />
          <span className="fw-bold">Cart Summary</span>
          <small className="text-muted">
            ({cart.length} item{cart.length !== 1 ? "s" : ""})
          </small>
          <motion.span
            animate={{ rotate: cartOpen ? 180 : 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <FontAwesomeIcon
              icon={faChevronUp}
              style={{
                color: "#222",
                transition: "transform 0.2s ease",
                fontSize: 14,
              }}
            />
          </motion.span>
        </span>
     
      </h5>

      {/* Animated collapse for cart items */}
      <AnimatePresence initial={false}>
        {cartOpen && (
          <motion.div
            key="cart-collapse"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            style={{ overflow: "hidden" }}
          >
            {cart.length === 0 ? (
              <div className="text-center text-muted py-3">
                Your cart is empty.
              </div>
            ) : (
              cart.map((item, index) => (
                <motion.div
                  key={index}
                  className="d-flex align-items-start mb-3 p-2 border rounded-3 bg-white"
                  onClick={() =>
                    handleEditCartModal({
                      id: item?.Item.id,
                      name: item?.Item?.name,
                      price: item?.Item.price,
                      special_instructions: item?.special_instructions,
                      image_url: item?.Item?.image_url,
                      Restaurant_Item_Attributes:
                        item?.Item?.Restaurant_Item_Attributes,
                      options: item?.options,
                      index,
                      category_id: item?.Item.category_id,
                    })
                  }
                  initial={{ y: 6, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.2, delay: index * 0.05 }}
                  whileHover={{
                    scale: 1.01,
                    boxShadow: "0 2px 8px rgba(157,42,0,0.15)",
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={item.Item.image_url || "/foodph.png"}
                    alt={item.Item.name || "Cart item"}
                    style={{
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: 10,
                      marginRight: "0.75rem",
                    }}
                  />
                  <div className="flex-grow-1">
                    <p className="fw-semibold text-dark mb-1">
                      {language === "en"
                        ? item?.Item?.name
                        : item?.Item?.chinese_name?.trim() ||
                          item?.Item?.name}
                    </p>

                    {item?.options?.map((opt, idx) => (
                      <p
                        className="text-muted small m-0"
                        key={idx}
                        style={{ lineHeight: 1.3 }}
                      >
                        {opt?.name || "Option"}{" "}
                        {opt?.priceModifier > 0
                          ? `+ $${opt.priceModifier}`
                          : ""}
                      </p>
                    ))}

                    {item?.special_instructions && (
                      <p className="small text-muted mb-0">
                        <strong>Note:</strong> {item.special_instructions}
                      </p>
                    )}
                  </div>

                  <div className="text-end ms-3">
                    <div
                      className="fw-bold text-dark"
                      style={{ fontSize: "0.95rem" }}
                    >
                      ${item.price}
                    </div>
                    <div
                      className="badge rounded-pill mt-1"
                      style={{
                        backgroundColor: THEME_COLOR,
                        color: "#fff",
                        fontSize: "0.8rem",
                      }}
                    >
                      ×{item.quantity}
                    </div>
                  </div>
                </motion.div>
              ))
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Footer Buttons */}
      <div className="d-flex justify-content-center gap-2 mt-3">
        {!cartOpen && (
          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            className="btn btn-outline-dark px-3 py-1 fw-semibold"
            style={{
              borderRadius: 20,
              fontSize: "0.9rem",
              color: "#222",
            }}
            onClick={() => setCartOpen(true)}
          >
            Show Cart
          </motion.button>
        )}

        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="btn text-white fw-semibold px-3 py-1"
          style={{
            backgroundColor: THEME_COLOR,
            borderRadius: 20,
            fontSize: "0.9rem",
          }}
          onClick={() => navigate('/online-order')}
        >
          + Add More
        </motion.button>
      </div>
    </div>


           <div
  className="p-4 rounded-4 shadow-sm mb-3 mt-3"
  style={{
    border: "1px solid rgba(157,42,0,0.15)",
  }}
>
  <h5
    className="fw-bold mb-3 d-flex align-items-center gap-2 text-dark"
    style={{ fontSize: "1.05rem" }}
  >
    <FontAwesomeIcon icon={faTags} style={{ color: "#9d2a00", fontSize: 18 }} />
    Promotion
  </h5>

  {/* Input */}
  <div className="d-flex align-items-center mb-2">
    <input
      type="text"
      className="form-control form-control-lg"
      placeholder="Enter promo code"
      value={promoCode}
      onChange={(e) => setPromoCode(e.target.value)}
      style={{
        borderRadius: "10px 0 0 10px",
        border: "1px solid #ddd",
        fontSize: "0.95rem",
        height: "46px",
      }}
    />
    <button
      className="btn text-white fw-semibold"
      onClick={(e) => checkCurrentCoupon(e)}
      disabled={checkingCoupon}
      style={{
        backgroundColor: "#9d2a00",
        borderRadius: "0 10px 10px 0",
        height: "46px",
        minWidth: "90px",
        border: "none",
      }}
    >
      {checkingCoupon ? (
        <span className="spinner-border spinner-border-sm"></span>
      ) : (
        "Apply"
      )}
    </button>
  </div>

  {/* Feedback Messages */}
  {checkCoupon && parseFloat(calculateSubtotal()) >= parseFloat(checkCoupon.min_require) && (
    <div
      className="d-flex align-items-center justify-content-between bg-success bg-opacity-10 p-3 rounded-3 mt-3"
      style={{ border: "1px solid rgba(25,135,84,0.25)" }}
    >
      <div className="text-success">
        <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
        <strong>Coupon applied!</strong> You saved ${calculateDiscount()}.
      </div>
      <button
        onClick={handleRemoveCoupon}
        className="btn btn-link text-decoration-none text-danger fw-semibold p-0"
      >
        Remove
      </button>
    </div>
  )}

  {checkCoupon && parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require) && (
    <div
      className="bg-warning bg-opacity-10 border p-3 rounded-3 mt-3"
      style={{ borderColor: "rgba(255,193,7,0.3)" }}
    >
      <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-warning" />
      <span className="text-dark">
        Minimum order amount of <strong>${checkCoupon.min_require}</strong> is required to use this coupon.
      </span>
    </div>
  )}

  {checkCoupon && checkCoupon.message && (
    <div className="bg-danger bg-opacity-10 border p-3 rounded-3 mt-3" style={{ borderColor: "rgba(220,53,69,0.3)" }}>
      <FontAwesomeIcon icon={faTimesCircle} className="me-2 text-danger" />
      <span className="text-danger fw-semibold">{checkCoupon.message}</span>
    </div>
  )}

  {!checkCoupon && couponError && (
    <div className="bg-danger bg-opacity-10 border p-3 rounded-3 mt-3" style={{ borderColor: "rgba(220,53,69,0.3)" }}>
      <FontAwesomeIcon icon={faTimesCircle} className="me-2 text-danger" />
      <span className="text-danger fw-semibold">{couponError || "Invalid coupon code."}</span>
    </div>
  )}
</div>



<div
  className="section border rounded-4 shadow-sm p-4 mb-4 bg-white"
  style={{ borderColor: "rgba(157,42,0,0.15)" }}
>
  {/* Section Header */}
  <h5
    className="fw-bold mb-2"
    style={{
      fontSize: "1rem",
      color: "#212529",
    }}
  >
    Customer Information <span className="text-danger">*</span>
  </h5>
  <p
    className="text-muted mb-3"
    style={{
      fontSize: "0.9rem",
      lineHeight: 1.5,
    }}
  >
    We’ll send your order updates via SMS — please enter your name and a valid phone number.
  </p>

  {/* Single Error Message (Top) */}
  {error && (
    <div
      className="alert alert-danger py-2 px-3 mb-3"
      role="alert"
      style={{
        fontSize: "0.9rem",
        fontWeight: 500,
        borderRadius: "10px",
      }}
    >
      {error}
    </div>
  )}

  {/* Inputs */}
  <div className="row g-3 align-items-end">
    {/* Name Field */}
    <div className="col-12 col-md-5" ref={nameRef}>
      <label
        htmlFor="name"
        className="form-label fw-semibold text-dark mb-1"
        style={{ fontSize: "0.9rem" }}
      >
        Name
      </label>
      <input
        type="text"
        id="name"
        className="form-control"
        placeholder="Enter your name"
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          setError("");
          setErrorStatus(null);
        }}
        maxLength={20}
        required
        style={{
          borderRadius: "10px",
          padding: "0.625rem 1rem",
          fontSize: "1rem",
          borderColor: errorStatus === 1 || errorStatus === 2 ? "red" : "#ced4da",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          transition: "all 0.2s ease",
          height: "50px",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#9d2a00";
          e.target.style.boxShadow = "0 0 0 0.2rem rgba(157,42,0,0.15)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor =
            errorStatus === 1 || errorStatus === 2 ? "red" : "#ced4da";
          e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.05)";
        }}
      />
    </div>

    {/* Phone Field */}
    <div className="col-12 col-md-7" ref={phoneRef}>
      <label
        htmlFor="phone"
        className="form-label fw-semibold text-dark mb-1"
        style={{ fontSize: "0.9rem" }}
      >
        Phone Number
      </label>
      <div className="input-group" style={{ height: "50px" }}>
        <span
          className="input-group-text"
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px 0 0 10px",
            borderColor:
              errorStatus === 1 || errorStatus === 3 || errorStatus === 4
                ? "red"
                : "#ced4da",
          }}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
            alt="US Flag"
            style={{
              width: 16,
              height: 14,
              borderRadius: 2,
              marginRight: 4,
            }}
          />
          +1
        </span>
        <input
          type="tel"
          id="phone"
          className="form-control"
          placeholder="(123) 456-7890"
          value={formatPhoneNumber(phone)}
          onChange={handlePhoneChange}
          required
          maxLength={14}
          style={{
            borderRadius: "0 10px 10px 0",
            padding: "0.625rem 1rem",
            fontSize: "1rem",
            borderColor:
              errorStatus === 1 || errorStatus === 3 || errorStatus === 4
                ? "red"
                : "#ced4da",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            transition: "all 0.2s ease",
            height: "50px",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#9d2a00";
            e.target.style.boxShadow = "0 0 0 0.2rem rgba(157,42,0,0.15)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor =
              errorStatus === 1 || errorStatus === 3 || errorStatus === 4
                ? "red"
                : "#ced4da";
            e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.05)";
          }}
        />
      </div>
    </div>
  </div>
</div>







       <div
  className="p-4 rounded-4 shadow-sm mb-3"
  style={{
    border: "1px solid rgba(157,42,0,0.15)",
  }}
>
  <h5
    className="fw-bold mb-4 d-flex align-items-center gap-2 text-dark"
    style={{ fontSize: "1.05rem" }}
  >
    <FontAwesomeIcon icon={faReceipt} style={{ color: "#9d2a00", fontSize: 18 }} />
    Order Summary
  </h5>

  <div className="mb-3">
    <div className="d-flex justify-content-between fw-bold mb-1">
      <span>Subtotal</span>
      <span className="fw-semibold text-dark">${calculateSubtotal()}</span>
    </div>

    <div className="d-flex justify-content-between fw-bold mb-1">
      <span>Taxes</span>
      <span className="fw-semibold text-dark">${calculateTaxes()}</span>
    </div>

    {orderMethod === "pickup" && (
      <div className="d-flex justify-content-between fw-bold mb-1">
        <span>Commission Fee</span>
        <span className="fw-semibold text-dark">
          ${parseFloat(fee?.commission_fee).toFixed(2)}
        </span>
      </div>
    )}

    {checkCoupon && parseFloat(calculateSubtotal()) >= parseFloat(checkCoupon.min_require) && (
      <div className="d-flex justify-content-between text-success mb-1">
        <span>Discount</span>
        <span>- ${calculateDiscount()}</span>
      </div>
    )}

    {orderMethod === "delivery" && (
      <>
        <div className="d-flex justify-content-between fw-bold mb-1">
          <span>Service Fee</span>
          <span className="fw-semibold text-dark">${calculateServiceFee()}</span>
        </div>
        <div className="d-flex justify-content-between fw-bold mb-1">
          <span>Delivery Fee</span>
          <span className="fw-semibold text-dark">${fee?.delivery_fee}</span>
        </div>
      </>
    )}

    <div className="d-flex justify-content-between fw-bold mb-1">
      <span>Tip</span>
      <span className="fw-semibold text-dark">
        ${parseFloat(customTip || calculateTip()).toFixed(2)}
      </span>
    </div>
  </div>

  {/* Tip Selection */}
 {/* Tip Selection */}
<div
  className="d-flex mb-4"
  style={{
    gap: "0", // no gap between buttons
    flexWrap: "nowrap",
  }}
>
  {[10, 15, 18].map((percent, idx) => (
    <button
      key={percent}
      className={`btn flex-fill fw-semibold ${
        tip === percent ? "text-white" : "text-dark border"
      }`}
      style={{
        backgroundColor: tip === percent ? "#9d2a00" : "#fff",
        borderColor: tip === percent ? "#9d2a00" : "#ddd",
        borderRadius:
          idx === 0
            ? "10px 0 0 10px"
            : idx === 2
            ? "0 10px 10px 0"
            : "0",
        transition: "all 0.2s ease",
        fontSize: "0.95rem",
        padding: "0.6rem 0",
      }}
      onClick={() => handleTipSelect(percent)}
    >
      {percent}%
    </button>
  ))}

  <button
    className="btn flex-fill fw-semibold text-dark border"
    style={{
      borderRadius: "0 10px 10px 0",
      borderColor: "#ddd",
      backgroundColor: "#fff",
      fontSize: "0.95rem",
      padding: "0.6rem 0",
    }}
    onClick={handleCustomTip}
  >
    Custom
  </button>
</div>

  {/* Total */}
  <div
    className="d-flex justify-content-between align-items-center border-top pt-3"
    style={{ borderColor: "rgba(157,42,0,0.2)" }}
  >
    <span className="fw-bold fs-5 text-dark">Total</span>
    <span className="fw-bold fs-5 text-dark">${calculateTotal()}</span>
  </div>
</div>

{/* Validation Messages */}
<div className="mt-2">
  {!needAmountReached() && (
    <p className="text-danger small mb-1">
      You need to reach the minimum amount to redeem the free item.
    </p>
  )}
  {orderMethod === "delivery" && calculateSubtotal() < 20 && (
    <p className="text-danger small mb-1">
      Minimum order amount of $20 in subtotal is required for delivery.
    </p>
  )}
  {orderMethod === "delivery" && !addressVerified && (
    <p className="text-danger small mb-1">
      Please enter a valid address within 5 miles of the restaurant.
    </p>
  )}
  {!isStoreOpen(restaurantId, restaurantHours) && (
    <p className="text-danger small mb-1">
      Sorry, we are currently closed. Refer to our store hours.
    </p>
  )}
</div>

{/* Place Order Button */}
<button
  className="btn w-100 fw-bold py-3 mt-3"
  style={{
    fontSize: "1.1rem",
    borderRadius: 14,
    backgroundColor: "#9d2a00",
    color: "#fff",
    boxShadow: "0 2px 6px rgba(157,42,0,0.3)",
    border: "none",
  }}
  disabled={
    (orderMethod === "delivery" && !addressVerified) ||
    !needAmountReached() ||
    (orderMethod === "delivery" && calculateSubtotal() < 20) ||
    !isStoreOpen(restaurantId, restaurantHours)
  }
  onClick={handlePlaceOrder}
>
  Place Order
</button>

          </Col>
        </Row>
        <EditCartModal modal={editCartModal} item={selectedItem} setModal={setEditCartModal} />
        <EditFreeItemModal modal={editFreeItem} item={selectedItem} setModal={setEditFreeItem} />
        <Modal show={showTipModal} onHide={() => setShowTipModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Enter Custom Tip</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="d-flex align-items-center justify-content-center">
              <button className="btn btn-outline-primary" onClick={decrementTip}>
                <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <Form.Control
                type="tel"
                min="0"
                value={customTip}
                onChange={handleCustomTipChange}
                placeholder="Enter custom tip amount"
                className="mx-2 text-center"
                style={{ maxWidth: '100px' }}
              />
              <button className="btn btn-outline-primary" onClick={incrementTip}>
                <FontAwesomeIcon icon={faChevronUp} />
              </button>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <button className="w-100 btn btn-primary" onClick={() => setShowTipModal(false)}>Save</button>
          </Modal.Footer>
        </Modal>
        <Modal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} backdropClassName="overlay" centered size="lg">


          <>
            <Modal.Header closeButton>
              <Modal.Title>Payment Method</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {paymentSubmitLoading ? (
                <Lottie
                  loop
                  animationData={loadingJson}
                  play
                />
              ) : (
                <>
                  <div className="d-flex">
                    {needDelivery ? (
                      <Button
                        variant='primary'
                        className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : 'outline-primary'}`}
                        onClick={() => handlePaymentMethodChange('online')}
                      >
                        Online Payment
                      </Button>
                    ) : (

                      <Button
                        variant='primary'

                        className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : 'outline-primary'}`}
                        onClick={() => handlePaymentMethodChange('online')}
                      >
                        Online Payment
                      </Button>

                    )}
                  </div>

                
                       {paymentOption === 'online' && (
                            <>
                          {paymentOption === 'online' && (
  <CheckoutApp
    key={restaurantId} // <== FORCE remount when restaurant changes
    tip={customTip || calculateTip()}
    restaurantId={restaurantId}
    name={name}
    phone={phone}
    cartItems={cart}
    coupon={calculateDiscount() > 0 ? checkCoupon?.coupon_id : null}
    address={needDelivery ? currentUserAddress : 'Pickup'}
  />
)}

                            </>
                          )}

                          {paymentOption === 'in-store' && (
                            <>
                              <Button variant='primary' className="black-button  p-3 mt-3" onClick={handlePayInStore} disabled={payinStoreLoading}>
                                {payinStoreLoading ? (
                                  <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                  'Place Order'
                                )}
                              </Button>
                            </>
                          )}
                </>
              )}
            </Modal.Body>

          </>
        </Modal>
      </Container>
    </>
  );
};

export default CheckoutPage;
